// API endpoints
export const API_ENDPOINTS = {
  ACCOUNT: {
    PAGE: "/auth/api/v1/manager/account/page",
    CREATE: "/auth/api/v1/manager/account/create",
    UPDATE: "/auth/api/v1/manager/account/update",
    DELETE: "/auth/api/v1/manager/account/delete",
    CHANGE_PASSWORD: "/auth/api/v1/manager/account/pwd/change",
    GET_ROLES: "/auth/api/v1/manager/account/roles",
    ASSIGN_ROLES: "/auth/api/v1/manager/account/authorize",
    REMOVE_ROLES: "/auth/api/v1/manager/account/authorize/remove", // 添加移除角色的端点
  },
  AUTH: {
    LOGIN: "/auth/api/v1/login/do-login",
    ACCOUNT_INFO: "/auth/api/v1/account/info",
    LIST_ACCOUNT: "/auth/api/v1/manager/account/options",
    STORE_USERS: "/wms/api/user/store-users",
    USER_INFO: "/wms/api/api/auth/userInfo",
    RESET_PASSWORD: "/auth/api/v1/login/account/pwd/update",
    UPDATE_WAREHOUSE: "/wms/api/api/auth/updateCurrentWarehouse",
  },
  ROLE: {
    PAGE: "/auth/api/v1/manager/role/page",
    CREATE: "/auth/api/v1/manager/role/create",
    UPDATE: "/auth/api/v1/manager/role/update",
    DELETE: "/auth/api/v1/manager/role/delete",
    UPDATE_MENU_PERMISSIONS: "/auth/api/v1/manager/role/authorize",
    QUERY_AUTHED_PERMISSIONS: "/auth/api/v1/manager/role/authed/menu/tree",
  },
  MENU: {
    TREE: "/auth/api/v1/manager/menu/tree",
    CREATE: "/auth/api/v1/manager/menu/create",
  },
  DATA_PERMISSION: {
    PAGE: "/auth/api/v1/manager/data-pms/page",
    CREATE: "/auth/api/v1/manager/data-pms/create",
    UPDATE: "/auth/api/v1/manager/data-pms/update",
    DELETE: "/auth/api/v1/manager/data-pms/delete",
  },
  STORE: {
    PAGE: "/wms/api/store/page",
    LIST: "/wms/api/store/multi-query",
  },
  CONTAINERS: {
    QUERY: "/wms/api/container/page",
    CREATE: "/wms/api/container/create", // POST: Create container via process
    CONTAINER_BATCH_UPDATE: "/wms/api/container/batch-update-status", // POST: Batch update containers
    CONTAINER_PRINT: "/wms/api/container/batch-print", // POST: print containers
  },
  FIXTURES: {
    PAGE: "/wms/api/fixture-type/page",
    QUERY_BY_ID: "/wms/api/fixture-type/get",
    CREATE: "/wms/api/fixture-type/create",
    UPDATE: "/wms/api/fixture-type/update",
    DELETE: "/wms/api/fixture-type/delete",
    BATCH_ACTIVE: "/wms/api/fixture-type/batch-enable",
    BATCH_DEACTIVE: "/wms/api/fixture-type/batch-disable",
    IMPORT: "/wms/api/fixture-type/import",
  },
  SECTION_TYPE: {
    PAGE: "/wms/api/section-type/page",
    LIST: "/wms/api/section-type/list",
    CREATE: "/wms/api/section-type/create",
    UPDATE: "/wms/api/section-type/update",
    DELETE: "/wms/api/section-type/delete",
    BATCH_ENABLE: "/wms/api/section-type/batch-enable",
    BATCH_DISABLE: "/wms/api/section-type/batch-disable",
    QUERY_BY_ID: "/wms/api/section-type/get",
    IMPORT: "/wms/api/section-type/import",
  },
  HQ_DISPLAY_GROUPS: {
    PAGE: "/wms/api/display-group/page",
    MULTI_QUERY: "/wms/api/display-group/multi-query",
    QUERY_BY_CODE: "/wms/api/display-group/get-by-code",
    CREATE: "/wms/api/display-group/create",
    UPDATE: "/wms/api/display-group/update",
    BATCH_ENABLE: "/wms/api/display-group/batch-enable",
    BATCH_DEACTIVE: "/wms/api/display-group/batch-disable",
  },
  STORE_GROUP: {
    PAGE: "/wms/api/store-group/page",
    QUERY_BY_CODE: "/wms/api/store-group/get-by-code",
    MULTI_QUERY: "/wms/api/store-group/multi-query",
    STORE_GROUP_STORES: "/wms/api/store-group/query-store-group-stores",
    CREATE: "/wms/api/store-group/create",
    UPDATE: "/wms/api/store-group/update",
    BATCH_ACTIVE: "/wms/api/store-group/batch-enable",
    BATCH_DEACTIVE: "/wms/api/store-group/batch-disable",
    EXPORT_ITEM_DATA: "/wms/api/store-group/export-typical-store-item",
    IMPORT_NIELSEN_DATA: "/wms/api/store-group/import-nielsen-data",
    QUERY_BENCHMARK_DATA: "/wms/api/store-group/benchmark",
    PAGE_BENCHMARK_DATA: "/wms/api/store-group-planogram/list",
    PLANOGRAM_SUBMIT_APPROVE: "/wms/api/store-group-planogram/submit-approve",
    EXPORT_NIELSEN_DATA: "/wms/api/store-group/export-nielsen-data",
    SET_AS_MAIN_VERSION: "/wms/api/store-group-planogram/set-as-main-version",
  },
  STORE_DISPLAY_GROUPS: {
    PAGE: "/wms/api/store-display-group/page",
    QUERY_BY_CODE: "/wms/api/store-display-group/get-by-code",
    OPTION_BY_STORE: "/wms/api/store-display-group/option-user-sdg",
    PLANOGRAM: {
      PAGE: "/wms/api/sdg-planogram/page",
      DETAIL: "/wms/api/sdg-planogram/detail",
      QUERY_BY_CODE: "/wms/api/sdg-planogram/get-by-code",
      MANUAL_TRIGGER_EXEC: "/wms/api/sdg-planogram/manual-trigger-exec",
    },
  },
  TEMPLATES: {
    PAGE: "/wms/api/planogram/template/page",
    LIST: "/wms/api/planogram/template/list",
    DETAIL: "/wms/api/planogram/template/get-by-id",
    CREATE: "/wms/api/planogram/template/create",
    UPDATE: "/wms/api/planogram/template/update",
    UPDATE_BASIC: "/wms/api/planogram/template/update-basic",
    DELETE: "/wms/api/planogram/template/delete",
    BATCH_ENABLE: "/wms/api/planogram/template/batch-enable",
    BATCH_DISABLE: "/wms/api/planogram/template/batch-disable",
    // PREVIEW_PLANS: '/wms/api/planogram-templates/preview-plans',
  },
  REFERENCE_DATA: {
    MILESTONE_TYPES: "/wms/api/planogram-templates/milestone-types",
    STORE_GROUPS: "/wms/api/planogram-templates/store-groups",
    STORES: "/wms/api/planogram-templates/stores",
    BUSINESS_ACTIVITIES: "/wms/api/planogram-templates/business-activities",
  },
  PLAN: {
    PAGE: "/wms/api/planogram-plans/page",
    QUERY_BY_ID: "/wms/api/planogram-plans/query-by-id", // GET: List plans with filters
    QUERY_PLAN_DETAILS: "/wms/api/planogram-plans/query-plan-details",
    // Plan operations
    PLAN_ACTIVATE: "/wms/api/planogram-plans/activate", // POST: Activate plan
    PLAN_PAUSE: "/wms/api/planogram-plans/pause", // POST: Pause plan
    PLAN_CANCEL: "/wms/api/planogram-plans/cancel", // POST: Cancel plan

    ASSIGNMENTS_GET: "/wms/api/planogram-plans/${Id}/assignments",
    ASSIGNMENTS_SAVE: "/wms/api/planogram-plans/assignments/save",
    ASSIGNMENTS_VALIDATE: "/wms/api/planogram-plans/assignments/validate",
    ASSIGNMENTS_SUBMIT: "/wms/api/planogram-plans/assignments/submit",
    AVALIABLE_PERSION: "/wms/api/operate-group/query-workers",
    MILESTONES_LIST: "/wms/api/planogram-plans/milestones/list",
    MILESTONES_STATUS_UPDATE:
      "/wms/api/planogram-plans/milestones/status/update",
  },
  PLAN_SUBTASK: {
    PAGE: "/wms/api/planogram-subtasks/page", // GET: 获取子任务列表
    PAGE_4_MY: "/wms/api/planogram-subtasks/page-4-my", // GET: 获取子任务列表
    CREATE: "/wms/api/planogram-subtasks/insert",
    UPDATE: "/wms/api/planogram-subtasks/update",
    DELETE: "/wms/api/planogram-subtasks/delete",
    CANCEL: "/wms/api/planogram-subtasks/cancel",
    QUERY_BY_CODE: "/wms/api/planogram-subtasks/query-by-code", // GET: 获取子任务详情
    SUBTASK_STATUS: "/wms/api/planogram-subtasks/update-status", // POST: 更新子任务状态
    BATCH_UPDATE_BY_PLAN: "/wms/api/planogram-subtasks/batch-update-by-plan", // POST: 批量更新子任务状态
    SUBTASK_START: "/wms/api/planogram-subtasks/start", // POST: 开始子任务
    SUBTASK_COMPLETE: "/wms/api/planogram-subtasks/complete", // POST: 完成子任务

    // 评论操作
    COMMENTS: "/wms/api/planogram-subtasks/comments/query-by-task", // GET: 获取评论列表
    COMMENT_ADD: "/wms/api/planogram-subtasks/add-comments", // POST: 添加评论

    // 附件操作
    ATTACHMENTS: "/wms/api/planogram-subtasks/attachments/query-by-task", // GET: 获取附件列表
    ATTACHMENT_UPLOAD: "/wms/api/planogram-subtasks/attachments/add", // POST: 上传附件
    ATTACHMENT_DELETE: "/wms/api/planogram-subtasks/attachments/delete", // DELETE: 删除附件
  },
  TASKS: {
    PAGE: "/wms/api/tally/order/page",
    PAGE_BY_STORE: "/wms/api/tally/order/page-by-store",
    QUERY_BY_CODE: "/wms/api/tally/order/get-by-code",
    QUERY_OUT_DETAILS: "/wms/api/tally/order-detail/out/get-by-order",
    QUERY_IN_DETAILS: "/wms/api/tally/order-detail/in/get-by-order",
    QUERY_NEW_DETAILS: "/wms/api/tally/order-detail/new/get-by-order",
    QUERY_REARRANGE_DETAILS:
      "/wms/api/tally/order-detail/rearrange/get-by-order",
    DETAILS: "/wms/api/tally/order-detail/get-by-order",
    BATCH_MARK_PRIORITY: "/wms/api/tally/order/modify-priority",
    BATCH_PAUSE: "/wms/api/tally/order/batch-pause",
    BATCH_RESUME: "/wms/api/tally/order/batch-resume",
    BATCH_ASSIGN_OWNER: "/wms/api/tally/order/batch-assign",
    // 添加获取反馈数据的端点
    GET_FEEDBACK: "/wms/api/tally/order/feedback/get-by-order",
    PAGE_FEEDBACK: "/wms/api/tally/order/feedback/page-4-hq",
    PAGE_FEEDBACK_4_STORE: "/wms/api/tally/order/feedback/page-4-store",
    FEEDBACK_FINISH: "/wms/api/tally/order/feedback/finish",
    FEEDBACK_REJECT: "/wms/api/tally/order/feedback/reject",
  },
  ITEM: {
    PAGE: "/wms/api/item/page",
    EXPORT: "/wms/api/item/export",
    LIST: "/wms/api/item/list",
    DETAIL: "/wms/api/item/get-by-code",
    BRAND_LIST: "/wms/api/item/list-brands",
    DISPLAY_CONFIG: "/wms/api/item/update-display-config",
    IMPORT_DISPLAY_CONFIG: "/wms/api/item/import-display-config",
  },
  CATEGORY: {
    PAGE: "/wms/api/category/page",
    LIST: "/wms/api/category/list",
    LIST_DIVISION: "/wms/api/category/queryByDivision",
    LIST_GROUP: "/wms/api/category/queryByGroup",
    LIST_DEPARTMENT: "/wms/api/category/queryByDepartment",
    LIST_CLASS: "/wms/api/category/queryByClass",
    LIST_SUB_CLASS: "/wms/api/category/queryBySubClass",
  },
  ITEM_STORE_RELATIONSHIP: {
    PAGE: "/wms/api/item-store-relationships/page",
    BATCH_UPDATE_DISPLAY_TYPE:
      "/wms/api/item-store-relationships/batch-update-display-type",
  },
  STORE_ITEM_INVENTORY: {
    PAGE: "/wms/api/store-item-inventory/page",
  },
  STORE_ITEM_SALE: {
    PAGE: "/wms/api/store-item-sale/page",
  },
  STORE_DISPLAY_GROUP_PLANOGRAM_APPLY: {
    PAGE: "/wms/api/sdg-planogram-apply/page",
    GET_BY_ID: "/wms/api/sdg-planogram-apply/get-by-id",
    AUDIT: "/wms/api/sdg-planogram-apply/audit",
    PLANOGRAM_OPTIONS: "/wms/api/sdg-planogram-apply/planogram-options",
    DISPLAY_GROUP_OPTIONS: "/wms/api/sdg-planogram-apply/display-group-options",
  },
  OPERATOR_GROUP: {
    PAGE: "/wms/api/operator-group/page",
    QUERY_BY_CODE: "/wms/api/operator-group/get-by-code",
    CREATE: "/wms/api/operator-group/create",
    UPDATE: "/wms/api/operator-group/update",
    DELETE: "/wms/api/operator-group/delete",
    BATCH_ENABLE: "/wms/api/operator-group/batch-enable",
    BATCH_DISENABLE: "/wms/api/operator-group/batch-disable",
  },
  PROMOTION_LOCATION_ITEM: {
    PAGE: "/wms/api/item-shelf-4-promote-location/page",
    IMPORT: "/wms/api/item-shelf-4-promote-location/import",
    DOWNLOAD_TEMPLATE: "/wms/api/item-shelf-4-promote-location/download",
    VALIDATE: "/wms/api/item-shelf-4-promote-location/validate",
  },
  ITEM_LOCATION_RELATIONSHIP: {
    PAGE: "/wms/api/item-shelf-location/page",
  },
  SHELF: {
    PAGE: "/wms/api/shelf/page",
    DOWNLOAD_STATISTICS: "/wms/api/shelf/export-statistic",
  },
};